<template>
  <div
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    v-loading="loading"
  >
    <el-row>
      <el-col :span="1.5">分类：</el-col>
      <el-col :span="22">
        <span class="chj" @click="classifyid = ''">
          <span :class="classifyid == '' ? 'huanghse' : 'huiche'">全部</span>
        </span>
        <span
          v-for="list in classifylist"
          :key="list.id"
          class="chj"
          @click="classifyid = list.id"
        >
          <span :class="classifyid == list.id ? 'huanghse' : 'huiche'">{{
            list.classifyName
          }}</span>
        </span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1.5">学科：</el-col>
      <el-col :span="22">
        <span class="chj" @click="sulistid = ''">
          <span :class="sulistid == '' ? 'huanghse' : 'huiche'">全部</span>
        </span>
        <span
          v-for="list in sulist"
          :key="list.id"
          class="chj"
          @click="sulistid = list.id"
        >
          <span :class="sulistid == list.id ? 'huanghse' : 'huiche'">{{
            list.name
          }}</span>
        </span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1.5">年级：</el-col>
      <el-col :span="22">
        <span class="chj" @click="gradeid = ''">
          <span :class="gradeid == '' ? 'huanghse' : 'huiche'">全部</span>
        </span>
        <span
          v-for="list in grade"
          :key="list.id"
          class="chj"
          @click="gradeid = list.id"
        >
          <span :class="gradeid == list.id ? 'huanghse' : 'huiche'">{{
            list.name
          }}</span>
        </span>
      </el-col>
    </el-row>
    <el-row v-if="schoolId!=0">
      <el-col :span="1.5">范围：</el-col>
      <el-col :span="22">
        <span class="chj" @click="scope = ''">
          <span :class="scope == '' ? 'huanghse' : 'huiche'">全部</span>
        </span>
        <span class="chj" @click="scope = schoolId" v-if="schoolId != '0'">
          <span :class="scope == schoolId ? 'huanghse' : 'huiche'">本校</span>
        </span>
      </el-col>
    </el-row>
    <el-row v-if="schoolId!=0">
      <el-col :span="1.5">发布状态：</el-col>
      <el-col :span="22">
        <span class="chj" @click="draft = '-1'">
          <span :class="draft == '-1' ? 'huanghse' : 'huiche'">全部</span>
        </span>
        <span class="chj" @click="draft = '1'">
          <span :class="draft == '1' ? 'huanghse' : 'huiche'">已发布</span>
        </span>
        <span class="chj" @click="draft = '0'">
          <span :class="draft == '0' ? 'huanghse' : 'huiche'">未发布</span>
        </span>
      </el-col>
    </el-row>
    <!-- <el-row>
			<el-col :span="1">版本：</el-col>
			<el-col :span="22">
				<span v-for="list in version" :key="list.verId" class="chj" @click="versionid=list.verId">
					<span :class="versionid==list.verId?'huanghse':'huiche'">{{list.verName}}</span>
				</span>
			</el-col>
		</el-row> -->
    <!-- <el-row>
			<el-col :span="1">年级：</el-col>
			<el-col :span="22">
				<span v-for="list in volume" :key="list.verId" class="chj" @click="volumeid=list.volumeId">
					<span :class="volumeid==list.volumeId?'huanghse':'huiche'">{{list.volumeName}}</span>
				</span>
			</el-col>
		</el-row> -->
    <div style="margin: 0 0 10px 0">
      <el-input
        v-model="courseName"
        placeholder="请输入课程名称关键词"
        style="width: 240px"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        class="el_button"
        @click="search()"
        >搜索</el-button
      >
      <el-button
        v-if="schoolId!=0"
        type="primary"
        icon="el-icon-circle-plus-outline"
        class="el_button"
        @click="addCourse()"
        >添加课程</el-button
      >
    </div>
    <div>
      <div v-if="datalist.length > 0" class="chehuif">
        共{{ totalCount }}个课程
      </div>
      <div>
        <div v-for="(list, index) in datalist" class="course_list" :key="index">
          <div class="pinhju" style="cursor: pointer">
            <el-image
              :src="list.serverHttp + list.courseImg"
              style="height: 135px"
              @click="dianji(list.lessonId, list.courseTypeid, list.roomType, list.rtmpUrl, list.liveStatus)"
            >
              <div slot="error" class="image-slot">
                <img
                  src="../../assets/img/zbmr.png"
                  width="100%"
                  height="135px"
                  @click="
                    dianji(
                      list.lessonId,
                      list.courseTypeid,
                      list.roomType,
                      list.rtmpUrl,
                      list.liveStatus
                    )
                  "
                />
              </div>
            </el-image>
            <div class="keshi" v-if="list.courseHour > 1">
              共{{ list.courseHour }}课时
            </div>
            <div class="course_name">{{ list.courseName || "暂无名称" }}</div>
            <div style="margin-top: 10px">
              <el-row>
                <el-col :span="22" style="color: #ff4616">
                  <span v-if="list.courseTypeid == 2">{{
                    list.courseSpeaker || "--"
                  }}</span>
                  <span v-if="list.courseTypeid == 1">
                    {{ yue(list.beginTime) }} {{ getWeekDay(list.beginTime) }}
                    {{ slices(list.beginTime, list.endTime) }}
                  </span>
                </el-col>
                <el-col :span="2" v-if="list.creatorId== creatorId&&list.roleType==roleType">
                  <i
                    class="el-icon-edit"
                    @click="editCourse(list.courseId)"
                  ></i>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="14">
                  <span class="lanm biao-span" v-if="list.classifyName">{{
                    list.classifyName
                  }}</span>
                  <span class="hongmu biao-span" v-if="list.courseLimit == 10"
                    >公开课</span
                  >
                  <span class="huanggu biao-span" v-if="list.courseLimit != 10"
                    >授权观看</span
                  >
                </el-col>
                <el-col :span="10" style="text-align: right; margin: 12px 0">
                  {{
                    list.courseViewnum > 10000
                      ? yuetu(list.courseViewnum)
                      : list.courseViewnum
                  }}次播放
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        class="yuanhuif"
        :page-size="15"
        :current-page.sync="curPage"
        @prev-click="gai"
        @next-click="gai"
        @current-change="gai"
        :hide-on-single-page="true"
        background
        layout="prev, pager, next"
        style="margin-top: 15px"
        :total="totalCount"
      ></el-pagination>
      <div
        v-if="datalist.length == 0"
        style="
          text-align: center;
          color: #666;
          line-height: 60px;
          padding-top: 40px;
        "
      >
        <img src="../../assets/img/wu.png" width="250px" />
        <div>暂无课程</div>
      </div>
    </div>
    <el-row :gutter="20">
      <!-- <el-col :span="4">
				<img src="../../assets/img/mulu.png" width="15px" style="vertical-align:middle;" />
				<span class="dazii">课程目录</span>
				<el-col :span="24" style="margin-top: 15px;">
					<el-tree
						default-expand-all
						highlight-current
						class="xiao-size"
						:data="data"
						:props="defaultProps"
						@node-click="handleNodeClick"
					></el-tree>
				</el-col>
			</el-col> -->

      <!-- <el-col :span="20" :offset="2">
				<el-col :span="24">
					<div v-if="datalist.length>0" class="chehuif">共{{totalCount}}个课程</div>
					<el-row :gutter="40">
						<el-col :span="6" v-for="(list,index) in datalist" :key="index" class="pouf">
							<div class="pinhju" style="cursor: pointer;" @click="dianji(list.lessonId,list.courseTypeid)">
								<el-image  :src="list.courseImg" style="height: 135px;">
									<div slot="error" class="image-slot">
										<img src="../../assets/img/mo.png" width="100%" height="135px" />
									</div>
								</el-image>
								<div class="keshi">共{{list.courseHour}}课时</div>
								<div style="font-weight: bold;">{{list.courseName}}</div>
								<div style="margin-top: 10px;">
									<el-row>
										<el-col :span="12">{{list.courseSpeaker}}</el-col>
										<el-col :span="12" style="text-align: right;">{{list.courseViewnum}}次观看</el-col>
									</el-row>
								</div>
							</div>
						</el-col>
					</el-row>
					<el-pagination
						class="yuanhuif"
						:page-size="12"
						:current-page.sync="curPage"
						@prev-click="gai"
						@next-click="gai"
						@current-change="gai"
						:hide-on-single-page="true"
						background
						layout="prev, pager, next"
						style="margin-top: 15px;"
						:total="totalCount"
					></el-pagination>
					<div
						v-if="datalist.length==0"
						style=" text-align: center;color: #666;line-height: 60px;padding-top: 40px;"
					>
						<img src="../../assets/img/wu.png" width="250px" />
						<div>暂无课程</div>
					</div>
				</el-col>
			</el-col> -->
    </el-row>
  </div>
</template>

<script>
import {
  courseclassifylist,
  coursesubjectlist,
  gradelist,
  //courseversion,
  //coursevolumelist,
  //bookchaptertreevo,
  courselist,
} from "@/api/home";
export default {
  data() {
    return {
      loading: false,
      classifylist: [],
      classifyid: "",
      sulist: [],
      sulistid: "",
      grade: [],
      gradeid: "",
      courseName: "",
      //version: [],
      //versionid: '',
      //volume: [],
      //volumeid: '',
      data: [],
      defaultProps: {
        children: "chapterList",
        label: "chapterName",
      },
      bookId: "",
      curPage: 1,
      chapterId: "",
      datalist: [],
      totalCount: 0,
      scope: "",
      draft: "-1",
      schoolId: "0",
      groupId: "1",
      roleType:"",
      creatorId:"",
    };
  },
  watch: {
    //课程分类
    classifyid() {
      this.courselist();
    },
    //学科
    sulistid() {
      this.courselist();
      //this.bookchaptertreevo()
    },
    //年级
    gradeid() {
      this.courselist();
    },
    //范围
    scope() {
      this.courselist();
    },
    //发布状态
    draft() {
      this.courselist();
    },
    //版本
    // versionid() {
    // 	this.coursevolumelist()
    // 	this.bookchaptertreevo()
    // },
    //年级(册别)
    // volumeid() {
    // 	this.bookchaptertreevo()
    // },
    //教材
    // bookId() {
    // 	if (this.bookId !== '') {
    // 		this.courselist()
    // 	}
    // },
  },
  methods: {
    // 课程分类
    courseclassifylist() {
      let that = this;
      that.loading = true;
      let params = {};
      courseclassifylist(params)
        .then((res) => {
          that.loading = false;
          console.log(res.data);
          that.classifylist = res.data.data;
          that.classifyid = "";
        })
        .catch(() => {
          that.loading = false;
        });
    },
    // 学科
    coursesubjectlist() {
      let that = this;
      that.loading = true;
      let params = {};
      coursesubjectlist(params)
        .then((res) => {
          that.loading = false;
          that.sulist = res.data.data;
          that.sulistid = "";
        })
        .catch(() => {
          that.loading = false;
        });
    },
    // 年级
    gradelist() {
      let that = this;
      that.loading = true;
      let params = {};
      gradelist(params)
        .then((res) => {
          that.loading = false;
          that.grade = res.data.data;
          that.gradetid = "";
        })
        .catch(() => {
          that.loading = false;
        });
    },
    // 教材版本
    courseversion() {
      let that = this;
      that.loading = true;
      let params = {
        subjectId: this.sulistid,
      };
      courseversion(params)
        .then((res) => {
          that.loading = false;
          that.version = res.data.data;
          that.versionid = res.data.data[0].verId;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    // 册别（年级）
    coursevolumelist() {
      let that = this;
      that.loading = true;
      let params = {
        subjectId: this.sulistid,
        versionId: this.versionid,
      };
      coursevolumelist(params)
        .then((res) => {
          that.loading = false;
          that.volume = res.data.data;
          that.volumeid = res.data.data[0].volumeId;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    // 章节
    bookchaptertreevo() {
      let that = this;
      that.loading = true;
      let params = {
        subjectId: this.sulistid,
        verId: this.versionid,
        volumeId: this.volumeid,
      };
      this.chapterId = "";
      this.bookId = "";
      bookchaptertreevo(params)
        .then((res) => {
          that.loading = false;
          that.bookId = res.data.data.bookId;
          that.data = res.data.data.chapterTreeVos;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    // 章节点击
    handleNodeClick(s) {
      if (s.chapterList == null) {
        this.chapterId = s.chapterId;
        this.courselist();
      }
    },
    // 查询课程
    courselist() {
      let that = this;
      that.loading = true;
      let params = {
        curPage: this.curPage,
        pageSize: 15,
        groupId: this.groupId,
        //courseTypeid: 2,
        courseState: this.draft,
        isHaveHour: 1,
        subjectId: that.sulistid,
        gradeId: this.gradeid,
        courseClassify: this.classifyid,
        courseName: this.courseName,
        schoolId: this.scope,
        //bookId: this.bookId,
        //chapterId: this.chapterId,
      };
      if(this.draft==0){
         this.$delete(params,'isHaveHour')
      }
      this.datalist = [];
      courselist(params)
        .then((res) => {
          that.loading = false;
          that.datalist = res.data.data.dataList;
          that.totalCount = res.data.data.totalCount;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    gai(s) {
      console.log(s);
      this.curPage = s;
      this.courselist();
    },
    // 课程点击
    dianji(lessonId, courseTypeId, roomType, rtmpUrl, liveStatus) {
      debugger
      if (courseTypeId == 2) {
        // 进入点播
        let routeData = this.$router.resolve({
          path: "/index",
          query: { id: lessonId },
        });
        window.open(routeData.href, "_blank");
      } else {
        // 进入直播 roomType=3 直播课堂，4 空中课堂（第三方）
        if (roomType == 3) {
          let routeData;
          if(liveStatus == 4) {
            routeData = this.$router.resolve({
              path: "/index",
              query: { id: lessonId },
            });
          } else {
            routeData = this.$router.resolve({
              path: "/live",
              query: { id: lessonId },
            });
          }
          window.open(routeData.href, "_blank");
        } else {
          if (rtmpUrl == "" || rtmpUrl == "#") {
            this.$message("课程资源不存在");
            return false;
          }
          window.open(rtmpUrl, "_blank");
        }
      }
    },
    //搜索
    search() {
      // if(this.courseName == '')
      // {
      // 	this.$message('请输入搜索关键词');
      // 	return false;
      // }
      this.courselist();
    },
    yue(s) {
      if (s) {
        return s.slice(5, 11);
      }
    },
    yuetu(s) {
      s = s / 10000;
      s = s.toFixed(2);
      return s + "万";
    },
    getWeekDay(dateString) {
      if (!dateString) {
        return false;
      }
      dateString = dateString.slice(0, 10);
      var dateArray = dateString.split("-");
      var date = new Date(
        dateArray[0],
        parseInt(dateArray[1] - 1),
        dateArray[2]
      );
      return "周" + "日一二三四五六".charAt(date.getDay());
    },
    slices(s, d) {
      if (s && d) {
        return s.slice(10, 16) + " -" + d.slice(10, 16);
      }
    },
    addCourse() {
      //添加课程
      this.$router.push({
        path: "/addCourse",
        query: {
          declareId: "",
        },
      });
    },
    editCourse(id) {
      //修改课程
      this.$router.push({
        path: "/addCourse",
        query: {
          id: id,
        },
      });
    },
  },
  created: function () {
    setTimeout(() => {
      if (localStorage.getItem("schoolId")) {
      this.schoolId = localStorage.getItem("schoolId");
      this.creatorId=localStorage.getItem("teacherId");
      this.roleType=localStorage.getItem("roleType");
      }else{
        this.draft="1";
      }
    }, 100);
    if (localStorage.getItem("groupId")) {
      this.groupId = localStorage.getItem("groupId");
    }
  },
  mounted() {
    this.courseclassifylist();
    this.coursesubjectlist();
    this.gradelist();
    this.courselist();
  },
};
</script>

<style scoped>
.course_list {
  display: inline-block;
  width: 20%;
}
.course_name {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el_button {
  background-color: #dd6058;
  color: #fff;
  border-color: #dd6058;
}
.biao-span {
  font-size: 12px !important;
  padding: 3px 8px;
  border-radius: 2px;
  float: left;
  display: inline-block;
  margin: 10px 0;
  margin-right: 5px;
}
.lanm {
  background: #e0f1ff;
  color: #64adea;
}
.hongmu {
  background: #ffdcd3;
  color: #ff4616;
}
.huanggu {
  background: #fff1d3;
  color: #e6a23c;
}
</style>



// WEBPACK FOOTER //
// src/components/index/dplay.vue